// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.checkbox-button {
  border-radius: 50px;
  background-color: white;
  border: 1px solid #707070;
  display: flex;
  padding: 5px 15px;
  margin: 5px 0;
}
.checkbox-button input[type=checkbox] {
  width: 18px;
  height: 18px;
  background: white;
  margin-right: 10px;
}
.checkbox-button input[type=text] {
  border-radius: 10px;
  background: white;
  border: 1px solid #D1D3D4;
  height: 25px;
  padding-left: 10px;
  min-width: 85%;
}
.checkbox-button input[type=text].input-warning {
  background: yellow;
}
.checkbox-button label {
  font-size: 0.9rem;
  min-width: 90px;
}

.checkbox-reason {
  margin: 5px auto;
  min-width: 300px;
  width: 45%;
}

.checked {
  background-color: #0669B3;
  border: 1px solid #0669B3;
  display: flex;
}
.checked input[type=checkbox] {
  width: 18px;
  height: 18px;
  background: #0669B3;
  margin-right: 10px;
}

.checked-kinder {
  background-color: #0669B3 !important;
  border: 1px solid #0669B3;
  display: flex;
  min-width: 350px;
  position: relative;
}
.checked-kinder label {
  color: white;
  font-weight: 500;
  width: 100%;
  min-width: 90px;
}
.checked-kinder .priority {
  bottom: 6px;
  font-size: 0.8rem;
  position: absolute;
  right: 10px;
}

#school-choice-other-input {
  min-width: 75%;
  width: 400px;
  contain: content;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/CheckboxBlock.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,mBDCsB;EACtB,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AAUJ;AATI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAWR;AATI;ECbA,mBDc0B;EACtB,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAWR;AATI;EACI,kBAAA;AAWR;AATI;EACI,iBAAA;EACA,eAAA;AAWR;;AARA;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;AAWJ;;AATA;EACI,yBDbS;ECcT,yBAAA;EACA,aAAA;AAYJ;AAVI;EACI,WAAA;EACA,YAAA;EACA,mBDpBK;ECqBL,kBAAA;AAYR;;AATA;EACI,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAYJ;AAXI;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAaR;AAXI;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAaR;;AATA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;AAYJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"./global/Colors.scss\";\n@import \"./global/globalMixins.scss\";\n\n.checkbox-button {\n    @include borderRadius(50px);\n    background-color: white;\n    border: 1px solid $grey3a;\n    display: flex;\n    padding: 5px 15px;\n    margin: 5px 0;\n    input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n        background:white;\n        margin-right: 10px;\n    }\n    input[type=\"text\"] {\n        @include borderRadius(10px);;\n        background: white;\n        border: 1px solid $grey1;\n        height: 25px;\n        padding-left: 10px;\n        min-width: 85%;\n    }\n    input[type=\"text\"].input-warning {\n        background: yellow;\n    }\n    label {\n        font-size: 0.9rem;\n        min-width: 90px;\n    }\n}\n.checkbox-reason {\n    margin: 5px auto;\n    min-width: 300px;\n    width: 45%;\n}\n.checked {\n    background-color: $pearl-blue;\n    border: 1px solid $pearl-blue;\n    display: flex;\n\n    input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n        background: $pearl-blue;\n        margin-right: 10px;\n    }\n}\n.checked-kinder {\n    background-color: $pearl-blue !important;\n    border: 1px solid $pearl-blue;\n    display: flex;\n    min-width: 350px;\n    position: relative;\n    label {\n        color: white;\n        font-weight: 500;\n        width: 100%;\n        min-width: 90px;\n    }\n    .priority {\n        bottom: 6px;\n        font-size: 0.8rem;\n        position: absolute;\n        right: 10px;\n    }\n}\n\n#school-choice-other-input {\n    min-width: 75%;\n    width: 400px;\n    contain: content;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
